/* Язык интерфейса.
 *
 * Раньше `type Lang` и функция `t` были объявлены заново в каждом экране —
 * пятнадцать одинаковых копий. Третий язык в такой форме означал бы правку в
 * пятнадцати местах, поэтому объявление тут одно на всех.
 *
 * Форма вызова `t(lang, 'по-русски', 'in English')` осталась прежней: их в
 * коде 734, и переписывать их на словари значило бы переписать половину
 * приложения ради одного языка. Китайский берётся по русской строке из
 * словаря `zh`, а чего в словаре нет — показывается по-английски. Молчаливый
 * откат на русский был бы хуже: в китайском интерфейсе кириллица не читается
 * вовсе, а латиница читается хоть как-то.
 */
import { ZH } from './zh'

export type Lang = 'ru' | 'en' | 'zh'

/** Порядок кнопок в переключателе языка. */
export const LANGS: readonly Lang[] = ['ru', 'en', 'zh'] as const

export function t(lang: Lang, ru: string, en: string): string {
  if (lang === 'en') return en
  if (lang === 'zh') return ZH[ru] ?? en
  return ru
}
